<div class="row">
    <div class="col-md-12">
        <ax-panel title="Agentes Expostos ao Paciente">
            <div class="row form-group">
                <div class="col-md-12">
                    <ax-edit-button [label]="'Lotacao/Atribuição'" 
                        (onClick)='pesquisa.abrirTelaCheia()'
                        [value]="lotacaoAtribuicaoTexto"></ax-edit-button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #gridAtivas
                    [dataSource]="registros"

                    [enableVirtualization]='true'  height='450' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    >
                    <e-columns>
                        <e-column field='id' width='120' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='riscoNome' [headerText]="'Risco'" [visible]="true"></e-column>
                        <e-column field='fatorRiscoNome' [headerText]="'Fator Risco'"></e-column>
                        <e-column field='agenteNome' [headerText]="'Agente'"></e-column>
                        <e-column field='esocial' [headerText]="'eSocial'"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
</div>

<app-lotacao-atribuicao-pesquisa #pesquisa (registroSelecionado)="lotacaoSelecionada($event)"></app-lotacao-atribuicao-pesquisa>

